module.exports = __webpack_public_path__ + "img/xia.b66f6ea1.gif";